import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { SpecRequest, SpecResponse } from './spec.types'
import { getSpec } from './spec'

const specQueryKeys = {
  base: ['spec'] as const,
  detail: ({ suite, project, runId, specFile }: Partial<SpecRequest>) => [
    'spec',
    suite,
    project,
    runId,
    specFile,
  ],
}

export const useGetSpec = (
  request: Partial<SpecRequest>
): UseQueryResult<SpecResponse> => {
  return useQuery<SpecResponse>({
    queryKey: specQueryKeys.detail(request),
    queryFn: () => getSpec(request as SpecRequest),
    enabled:
      !!request.suite &&
      !!request.project &&
      !!request.runId &&
      !!request.specFile,
  })
}
